import React from 'react';
import './FlowerServices.css';
import { SERVICES, SHOP_INFO } from '../../../../shared/constants/shopData';

export const FlowerServices: React.FC = () => {
    return (
        <section className="services-section" id="services">
            <div className="container">
                <div className="services-header">
                    <h2 className="section-title">Наши услуги</h2>
                    <p className="section-subtitle">
                        Мы предлагаем полный спектр цветочных услуг — от готовых букетов до комплексного оформления мероприятий
                    </p>
                </div>

                <div className="services-grid">
                    {SERVICES.map((service) => (
                        <div className="service-card" key={service.id}>
                            <div className="service-image-container">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="service-image"
                                    loading="lazy"
                                />
                                <div className="service-icon">{service.icon}</div>
                            </div>

                            <div className="service-content">
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>

                                <ul className="service-features">
                                    {service.features.map((feature, index) => (
                                        <li key={index} className="feature-item">
                                            <span className="feature-check">✓</span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                <a href={service.url}>
                                    <button
                                        className="service-button"
                                        aria-label={`Узнать больше о ${service.title}`}
                                    >
                                        Узнать больше
                                    </button>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="services-cta">
                    <p className="cta-text">
                        Нужна помощь в выборе? Наши флористы помогут подобрать идеальное решение для вашего случая
                    </p>
                    <a href={`tel:${SHOP_INFO.phoneClean}`}>
                        <button className="cta-button">
                            Получить консультацию
                        </button>
                    </a>
                </div>
            </div>
        </section>
    );
};